import Logo from '../Logo'
import styles from './Navigation.module.css'
import cx from 'classnames'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

type NavigationProps = {
    elements: { label: string; path: string }[]
}

const Navigation: React.FC<NavigationProps> = ({ elements }) => {
    const { logout } = useAuth()
    const [burgerToggle, setBurgerToggle] = useState<boolean>(false)
    const navigate = useNavigate()

    return (
        <nav className={cx(styles['zr-nav'])}>
            <div className={cx(styles['zr-logo'])}>
                <Logo />
                <span>ZR Customizer</span>
            </div>
            <div className={cx(styles['zr-desktop-nav'])}>
                <ul>
                    {elements.map((element, index) => (
                        <li key={index} onClick={() => navigate(element.path)}>
                            {element.label}
                        </li>
                    ))}
                    <li
                        onClick={() => logout()}
                        className={cx(styles['zr-fullscreen-icon'])}
                    >
                        &#x26BF;
                    </li>
                </ul>
            </div>
            <label className={cx(styles['zr-burger-menu'])} htmlFor="zr-burger">
                <input
                    className={cx(styles['zr-hidden'])}
                    id="zr-burger"
                    type="checkbox"
                    onChange={() => setBurgerToggle((prev) => !prev)}
                />
                <span />
            </label>
            <div
                className={cx(
                    styles['zr-mobile-nav'],
                    burgerToggle && styles['zr-checked']
                )}
            >
                <ul>
                    {elements.map((element, index) => (
                        <li key={index} onClick={() => navigate(element.path)}>
                            {element.label}
                        </li>
                    ))}
                    <li
                        onClick={() => logout()}
                        className={cx(styles['zr-fullscreen-icon-mobile'])}
                    >
                        &#x26BF; Logout
                    </li>
                    <li
                        className={cx(styles['zr-fullscreen-icon-mobile'])}
                        onClick={() => {
                            setBurgerToggle(false)
                        }}
                    >
                        &#x26F6; Fullscreen
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Navigation
